import React, {useState, useEffect} from 'react';
import useApi from '../../Hooks/useApi'

import './Home.css';

// custom components
import InventoryDataTable from '../../Components/InventoryDataTable/InventoryDataTable'
//carbon components
import { DataTableSkeleton, ToastNotification } from 'carbon-components-react';

function Home(props) {
  // check route if you are in add items mode
  const urlParams = window.location.search.substr(1, window.location.search.length);
  let addMode = false;
  let editMode = false;
  if (urlParams === "mode=add") {
    addMode = true;
  } else if (urlParams === "mode=edit") {
      editMode = true;
  }

  //get props
  const {token, quoteItems, setQuoteItems, quoteToEdit, setQuoteToEdit } = props
  //set state
  const [refresh, setRefresh] = useState(false)
  const [notification, setNotification] = useState(false)
  const [notificationContent, setNotificationContent] = useState({})
  // fetch the inventory data
  const apiPath = '/items';
  const {error, loading, data, fetchData} = useApi(token, apiPath)

  useEffect( () => {
    if (!data || !data[0].pulledAt) {
      // alert("There was an error during the data fetch. Please reload the page or go back to the quote creation and re-enter this screen.")
      return
    }

    console.log(data[0].pulledAt);
    let pulledTime = new Date(data[0].pulledAt).getTime();
    let now = new Date().getTime();
    let differenceInMilliseconds = now - pulledTime;
    let differenceInSeconds = differenceInMilliseconds / 1000;

    console.log("Data was updated", differenceInSeconds, "seconds ago");

    //show warning if
    if (differenceInSeconds > 300) {
      setNotification(true)
      setNotificationContent({
        title: "Warning",
        caption: "E&A API is not responding, unable to refresh database.",
        type: "warning"
      })

    }


  }, [data])


  // additional table-specific vars
  const collator = new Intl.Collator();
  const propSortInfo = {
    columnId: 'description',
    direction: 'NONE',
  };

  //render functions
  const renderPageTitleText = () => {
    if (addMode || editMode) {
      return 'Add Inventory Item';
    } else {
      return 'Live Inventory';
    }
  }

  //UI Rendering

  // TEMPORARY UI FOR BILLING ERROR  
  // return (
  //   <div id="homeContainer">
  //     <h3 id="homeTitle">{renderPageTitleText()}</h3>
  //     <h5 style={{textAlign: "center", marginTop: 50, color: "red"}}>
  //       Infrastructure Error: Client cannot connect to the backend instance
  //     </h5>
  //     <div id="skeletonDataTableCont">
  //       <DataTableSkeleton columnCount={3} showToolbar={false} id="skeletonTable">
  //       </DataTableSkeleton>
  //     </div>
  //   </div>
  // )
  // --- END OF TEMPORARY UI FOR BILLING ERROR

  if (error) {
    console.error(error)
    return (
      <div id="errorContainer">
        <p id="errorMsgRoot">An error has occurred, please refresh the page</p>
      </div>
    )
  }

  if (loading) {
    return (
    <div id="homeContainer">
      <h3 id="homeTitle">{renderPageTitleText()}</h3>
      <div id="skeletonDataTableCont">
        <DataTableSkeleton columnCount={3} showToolbar={false} id="skeletonTable">
        </DataTableSkeleton>
      </div>
    </div>
    )
  }

  return (
    <div id="homeContainer">

      { notification ?  <ToastNotification lowContrast={false} className="appNotification slide-in-top" title={notificationContent.title} kind={notificationContent.type} caption={notificationContent.caption} /> : null }

      <h3 id="homeTitle">{renderPageTitleText()}</h3>
      <InventoryDataTable collator={collator} propSortInfo={propSortInfo} quoteItems={quoteItems} setQuoteItems={setQuoteItems} quoteToEdit={quoteToEdit} setQuoteToEdit={setQuoteToEdit} inventoryData={data} refreshData={fetchData} />
    </div>
  );
}

export default Home;
